module.exports = __webpack_public_path__ + "img/tpc-29.7486c15c.jpg";